import { buildHref } from "@softmax/web-addresses";
import { publicLinks } from "@softmax/web-addresses/discovery";
import { linkAccount } from "@softmax/web-features/session/commands";
import type { LinkedAccount } from "@softmax/product-ux/account";
import type { LinkedAccounts } from "../account.types";

export function linkedAccountControls({
  linkedAccounts,
  userId,
}: {
  linkedAccounts: LinkedAccounts;
  userId: string;
}): LinkedAccount[] {
  const accounts: LinkedAccount[] = [];

  if (linkedAccounts.discordUserId)
    accounts.push({
      provider: "discord",
      status: "linked",
      profileHref: `https://discord.com/users/${linkedAccounts.discordUserId}`,
      communityHref: publicLinks.discord,
    });
  else if (linkedAccounts.discordEnabled)
    accounts.push({
      provider: "discord",
      status: "available",
      onLink: () =>
        void linkAccount({
          userId,
          provider: "discord",
          callbackUrl: buildHref({ name: "account" }),
        }),
    });

  if (linkedAccounts.githubLinked)
    accounts.push({
      provider: "github",
      status: "linked",
      onTeamRoster: linkedAccounts.githubOnRoster,
    });
  else if (linkedAccounts.githubEnabled)
    accounts.push({
      provider: "github",
      status: "available",
      onLink: () =>
        void linkAccount({
          userId,
          provider: "github",
          callbackUrl: buildHref({ name: "account" }),
        }),
    });

  return accounts;
}
